import Flex from 'legacyfrontend/components/Flex';
import totalNightTextSetter from 'legacyfrontend/utils/total-night-text';
import HotelInfoCard from './components/PackageHotelInfoCard';

const PackageHotelsInfo = ({ totalNights, hotelInformation, provider_id, packageDescriptions }) => {
  return (
    <Flex className='package-information__hotels-card__list' vertical>
      {hotelInformation.map((hotel) => (
        <HotelInfoCard
          hotel={hotel}
          hotelInformation={hotelInformation}
          key={hotel.id}
          packageDescriptions={packageDescriptions}
          provider_id={provider_id}
          totalNightText={totalNightTextSetter(provider_id === 3 ? hotel.nights : totalNights)}
        />
      ))}
    </Flex>
  );
};

export default PackageHotelsInfo;
